export default __webpack_public_path__ + "static/media/Artboard 13.fb16fc4f.png";